// extracted by mini-css-extract-plugin
export default {"medalRequests":"MedalRequests_medalRequests__6NZnk"};